import { getNextColor } from "@fluentui/react-charting";
import { useContext, useEffect } from "react";
import DisplayAPIsException from "../../../../BasicComponents/DisplayAPIsExceptionAlert";
import FunnelChart from "../../../../ChartComponents/FunnelChart";
import { CustomShimmer } from "../../../../helper/CustomShimmer";
import CustomCard from "../../../../SharedComponents/CustomCard";
import { OverviewAndSummaryMutationContext } from "../../ProductView";
import { PRODUCT_VIEW_DATA } from "../../Common/ProductView.constants";
import { arrSortAscByKeyValue } from "../../../../Utils/js-common";
import { logEvent } from "../../../../helper/AppInsightsHelper";
import { ProductViewFiltersContext } from "../../../../pages/ProductView";

export const KeyMetricsFunnelView = () => {
  const { data, error, isLoading, isError } = useContext(OverviewAndSummaryMutationContext);
  const filters = useContext(ProductViewFiltersContext);

  const customProps = {
    productName: filters?.productName,
    productFilters: JSON.stringify(filters)
  };

  useEffect(() => {
    logEvent("Funnel View", "Product View Page", "KeyMetricsFunnelView", customProps);
  }, []);

  const getTenantsMetricsFunnelData = (): any[] => {
    const sortedMappedData = arrSortAscByKeyValue({
      key: "productKPIName",
      data: data?.overviewData || []
    }).map((mmetric, index) => ({
      ...mmetric,
      color: getNextColor(index)
    }));
    const keyMetricsList =
      data?.summaryData?.filter((x) => x.isTenantMetrics != "0")[0]?.data?.map((x: any) => x.name) || [];
    const filteredMetrics = sortedMappedData.filter(
      ({ productKPIName }) => keyMetricsList.indexOf(productKPIName) > -1
    );

    return filteredMetrics
      ?.map((card) => ({
        x: card.productKPIName,
        y: Number(card.currentValue.replaceAll(",", "")),
        z: card.order,
        abbValue: card.abbrevatedValue,
        color: card.color
      }))
      .sort((a: any, b: any) => a.z - b.z);
  };

  const getKeyMetricsFunnelData = (): any[] => {
    const sortedMappedData = arrSortAscByKeyValue({
      key: "productKPIName",
      data: data?.overviewData || []
    }).map((mmetric, index) => ({
      ...mmetric,
      color: getNextColor(index)
    }));
    const keyMetricsList =
      data?.summaryData?.filter((x) => x.isTenantMetrics == "0")[0]?.data?.map((x: any) => x.name) || [];
    const filteredMetrics = sortedMappedData.filter(
      ({ productKPIName }) => keyMetricsList.indexOf(productKPIName) > -1
    );

    return filteredMetrics
      ?.map((card) => ({
        x: card.productKPIName,
        y: Number(card.currentValue.replaceAll(",", "")),
        z: card.order,
        abbValue: card.abbrevatedValue,
        color: card.color
      }))
      .sort((a: any, b: any) => a.z - b.z);
  };

  const getKustoLink: any = (data: any[], isTenantMetrics: 0 | 1 = 0) =>
    data?.filter((x) => x.isTenantMetrics === String(isTenantMetrics))[0]?.kustoLink;

  const displayTenantsFunnel = !isError && <FunnelChart width="100%" data={getTenantsMetricsFunnelData()} />;
  const displayKeysFunnel = !isError && <FunnelChart width="100%" data={getKeyMetricsFunnelData()} />;
  const displayAPIsException = (
    <div style={{ paddingTop: 35 }}>
      <DisplayAPIsException error={error} height={345} />
    </div>
  );

  if (!isLoading && isError) {
    return displayAPIsException;
  }

  return (
    <div style={{ display: "flex", justifyContent: "space-around", flexDirection: "row" }}>
      <div style={{ display: "contents" }}>
        <CustomCard
          cardHeaderTitle={PRODUCT_VIEW_DATA.TABS.TAB.TENANTS_METRICS_FUNNEL_VIEW.CARD_HEADER}
          styles={{ root: { width: "40%" } }}
          kustoLink={getKustoLink(data?.summaryData || [], 1)}
          chartTitle={PRODUCT_VIEW_DATA.TABS.TAB.TENANTS_METRICS_FUNNEL_VIEW.CARD_HEADER.title}
        >
          {isLoading ? <CustomShimmer columnCount={2} /> : displayTenantsFunnel || displayAPIsException}
        </CustomCard>
      </div>
      <div style={{ display: "contents" }}>
        <CustomCard
          cardHeaderTitle={PRODUCT_VIEW_DATA.TABS.TAB.KEY_METRICS_FUNNEL_VIEW.CARD_HEADER}
          styles={{ root: { width: "40%" } }}
          kustoLink={getKustoLink(data?.summaryData || [], 0)}
          chartTitle={PRODUCT_VIEW_DATA.TABS.TAB.KEY_METRICS_FUNNEL_VIEW.CARD_HEADER.title}
        >
          {isLoading ? <CustomShimmer columnCount={2} /> : displayKeysFunnel || displayAPIsException}
        </CustomCard>
      </div>
    </div>
  );
};
